import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

//run on load
//keep this clean and less jitter with sass and make used data attributes opacity 0
$( () => {
  //activate scrolltrigger
  gsap.registerPlugin( ScrollTrigger );

  //basic fade in
  if( $( ['data-fade'] ).length ) {
    let fadeItem = document.querySelectorAll( '[data-fade]' )
  
    fadeItem.forEach( ( item ) => {
      gsap.fromTo( 
        item, { 
          opacity: 0, 
          y: 50 
        }, {    
          opacity: 1,
          y: 0,
          duration: 0.27,

          scrollTrigger: {
            trigger: item,
            start: 'top bottom-=200'
          }
        }
      )
    } )
  }

  //basic waterfall
  if( $( ['data-waterfall'] ).length ) {
    let waterfallItems = document.querySelectorAll( '[data-waterfall]' );
  
    waterfallItems.forEach( ( item ) => {
      gsap.fromTo( 
        $( item ).children(), {
          opacity: 0 
        }, {
          opacity: 1,
          duration: 0.325,
          stagger: 0.125,

          scrollTrigger: {
            trigger: item,
            start: 'top bottom-=200'
          }
        }
      )
    })
  }

  // Hover Effect on Home Page
  if( $( '.hover-alternate' ).length ) {
    let hoverAlternate = document.querySelectorAll( '.hover-alternate' );

    $( hoverAlternate ).on( 'mouseenter', function() {
      $( hoverAlternate ).addClass( 'inactive' )
      $( this ).addClass( 'active' );
    } )

    $( hoverAlternate ).on( 'mouseleave', function() {
      $( hoverAlternate ).removeClass( 'inactive' )
      $( this ).removeClass( 'active' );
    } )
  }


  // Load More in Videos Page
  if( $( '.load-more' ).length ) {
    let loadMore = document.querySelector( '.load-more' )

    $( loadMore ).on( 'click', () => {
        $( '.video-wrapper.hide' ).slice( 0, 4 ).removeClass( 'hide' );
        $( '.video-wrapper.hide' ).length ? $( loadMore ).removeClass( 'hide' ) : $( loadMore ).addClass( 'hide' )
    })
  }

  // Hover Grid In Custom Build Page
  if( $( '.hover-grid .card' ).length ) {
    $( '.hover-grid .card' ).on( 'mouseover', function() {
      let cardData = $( this ).data( 'custom' )
      $( '.main-image img' ).removeClass( 'active' )
      $( `.main-image img[data-custom="${ cardData }"]` ).addClass( 'active' )
    } )
  }

  // Calculator on Custom Build Page
  if( $( '.custom-calculator' ).length ) {
    let futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 185);
    let date = futureDate.toISOString().split('T')[0];
    let initalDelivery = new Date( futureDate.setDate( futureDate.getDate() - 185 ) ).toISOString().split('T')[0];
    $( '#delivery' ).val( date );
    $( '.contract-signing-date' ).text( initalDelivery )

    $( '#delivery' ).on( 'change', function() {
      let selectedDate = new Date( $( this ).val() )
      let deliveredDate = new Date( selectedDate.setDate( selectedDate.getDate()-185 ) ).toISOString().split('T')[0];
      
      $( '.contract-signing-date' ).text( deliveredDate )
    } )
  }
})